import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { thunkToAction } from 'typescript-fsa-redux-thunk';

import {
	authLogin,
	authNetworkStatusSelector,
} from '@redux';

export const useLogin = () => {
	const dispatch = useDispatch();
	const networkStatus = useSelector(authNetworkStatusSelector);
	const [login, setLogin] = useState('');
	const [password, setPassword] = useState('');

	const onLoginChange = (value: string) => setLogin(value);

	const onPasswordChange = (value: string) => setPassword(value);

	const onSubmit = async () => {
		try {
			await dispatch(thunkToAction(authLogin.action)({ login, password }));
		} catch {
			// Ошибка отображается через networkStatus.error
		}
	};

	return {
		login,
		password,
		networkStatus,
		onLoginChange,
		onPasswordChange,
		onSubmit,
	};
};
